import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

function Box({ children }) {
  return (
    <div
      style={{
        display: "block",
        lineHeight: 1,
      }}
    >
      {children}
    </div>
  );
}

const EventTileSkeleton = ({ vertical }) => {
  const size = vertical ? 146 : 120;

  return (
    <SkeletonTheme
      baseColor="#D8DBE0"
      highlightColor="#EDF1F6"
      borderRadius={"4px"}
    >
      <div
        style={{
          display: "flex",
          flexDirection: vertical ? "column" : "row",
          padding: 8,
          gap: vertical ? 8 : 16,
          borderRadius: 8,
          border: "1px solid #EDF1F6",
          background: "#FFFFFF",
          boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.08)",
          flex: "1 0 0",
        }}
      >
        <Skeleton wrapper={Box} width={size} height={size} />
        <div
          style={{
            display: "flex",
            padding: "8px 0",
            flexDirection: "column",
            gap: 4,
            flex: "1 0 0",
          }}
        >
          <Skeleton wrapper={Box} width={"25%"} height={13} />
          <Skeleton wrapper={Box} width={"75%"} height={20} />
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default EventTileSkeleton;
